/**
 * `cn()` — concatenate Tailwind class names with conflict resolution.
 *
 * Combines clsx (conditional classes) with tailwind-merge (last-one-wins
 * for conflicting Tailwind utilities like `p-2` vs `p-4`).
 */

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
